
function ShareIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
    >
      <g
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        clipPath="url(#clip0_384_2265)"
      >
        <path d="M18.333 1.736l-9.166 9.167M18.333 1.736L12.5 18.403l-3.333-7.5-7.5-3.333 16.666-5.834z"></path>
      </g>
      <defs>
        <clipPath id="clip0_384_2265">
          <path
            fill="#fff"
            d="M0 0H20V20H0z"
            transform="translate(0 .07)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default ShareIcon;